import React, { useRef } from 'react';
import FaxSend2 from './FaxSend2';
import ReactToPrint from './ReactToPrint';
import { Modal } from 'react-bootstrap';

const EncounterView = ({ show, jid, title, PMHID, lang, onClose }) => {
  const printContent = useRef(null);
  const print = useRef(null);

  const handlePrint = () => {
    print.current.handlePrint();
  };

  return (
    <Modal show={show} onHide={onClose} bsSize="lg" restoreFocus={false}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body
        id="printArea"
        style={{
          maxHeight: 'calc(100vh - 200px)',
          overflowY: 'auto',
        }}
      >
        {PMHID && (
          <React.Fragment>
            <div ref={printContent}>
              <FaxSend2 PMHID={PMHID} />
            </div>
            <ReactToPrint ref={print} content={() => printContent.current} trigger={() => {}} />
          </React.Fragment>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button onClick={handlePrint} className="btn btn-warn" type="button">
          Print
        </button>
        <button onClick={onClose} type="button" className="btn btn-info" data-dismiss="modal">
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default EncounterView;
